import { filter, get, isEmpty, uniqBy } from 'lodash';
import update from 'react-addons-update';
import getNDFL3Reducer from '../../redux/ndfl3Saga/NDFL3Reducer';

/**
 * action types
 */

export const GET_COUNTRIES_SUCCESS = 'GET_COUNTRIES_SUCCESS';
export const GET_2NDFL_SUCCESS = 'GET_2NDFL_SUCCESS';
export const GET_DOCUMENT_TYPES_SUCCESS = 'GET_DOCUMENT_TYPES_SUCCESS';
export const GET_TAX_AUTHORITIES_CONTACTS = 'GET_TAX_AUTHORITIES_CONTACTS';
export const GET_INCOME_SOURCE_BY_2NDFL_SUCCESS = 'GET_INCOME_SOURCE_BY_2NDFL_SUCCESS';

export const SELECT_CHECKBOX_2NDFL = 'SELECT_CHECKBOX_2NDFL';
export const DISABLE_CHECKBOX_2NDFL = 'DISABLE_CHECKBOX_2NDFL';

export const INIT_3NDFL_DRAFT_SUCCESS = 'INIT_3NDFL_DRAFT_SUCCESS';
export const CLEAR_3NDFL_DRAFT = 'CLEAR_3NDFL_DRAFT';
export const GET_3NDFL_DRAFT_SUCCESS = 'GET_3NDFL_DRAFT_SUCCESS';
export const SAVE_3NDFL_DRAFT_SUCCESS = 'SAVE_3NDFL_DRAFT_SUCCESS';
export const SAVE_3NDFL_DRAFT_ERROR = 'SAVE_3NDFL_DRAFT_ERROR';
export const CREATE_3NDFL_XML_DRAFT_REQUEST = 'CREATE_3NDFL_XML_DRAFT_REQUEST';
export const CREATE_3NDFL_XML_DRAFT_SUCCESS = 'CREATE_3NDFL_XML_DRAFT_SUCCESS';
export const CREATE_3NDFL_XML_DRAFT_ERROR = 'CREATE_3NDFL_XML_DRAFT_ERROR';
export const SET_LOGOUT = 'SET_LOGOUT';
export const GET_CHECKS_SUCCESS = 'GET_CHECKS_SUCCESS';
export const COMPLETE_FORM_SUBMIT = 'COMPLETE_FORM_SUBMIT';
export const RESET_FORM_SUBMIT = 'RESET_FORM_SUBMIT';

/**
 * action creators
 */

export function getCountriesSuccess(payload) {
  return {
    type: GET_COUNTRIES_SUCCESS,
    payload,
  };
}

export function get2NDFLSuccess(payload) {
  return {
    type: GET_2NDFL_SUCCESS,
    payload,
  };
}

export function getIncomeSourceBy2ndflSuccess(payload) {
  return {
    type: GET_INCOME_SOURCE_BY_2NDFL_SUCCESS,
    payload,
  };
}

export function getDocumentTypesSuccess(payload) {
  return {
    type: GET_DOCUMENT_TYPES_SUCCESS,
    payload,
  };
}

export function getTaxAuthoritiesContactsSuccess(payload) {
  return {
    type: GET_TAX_AUTHORITIES_CONTACTS,
    payload,
  };
}

export function clear3NDFLDraft() {
  return {
    type: CLEAR_3NDFL_DRAFT,
  };
}

export function init3NDFLDraftSuccess(ndfl3Package) {
  return {
    type: INIT_3NDFL_DRAFT_SUCCESS,
    ndfl3Package,
  };
}

export function get3NDFLDraftSuccess(ndfl3Package) {
  return {
    type: GET_3NDFL_DRAFT_SUCCESS,
    ndfl3Package,
  };
}

export function save3NDFLDraftSuccess(responseNdfl3Package) {
  return {
    type: SAVE_3NDFL_DRAFT_SUCCESS,
    responseNdfl3Package,
  };
}

export function save3NDFLDraftError(error) {
  return {
    type: SAVE_3NDFL_DRAFT_ERROR,
    error,
  };
}

export function create3ndflXmlDraftSuccess(xmlDraft) {
  return {
    type: CREATE_3NDFL_XML_DRAFT_SUCCESS,
    xmlDraft,
  };
}

export function create3ndflXmlDraftError(response) {
  return {
    type: CREATE_3NDFL_XML_DRAFT_ERROR,
    payload: response,
  };
}

export function setLogout(payload) {
  return {
    type: SET_LOGOUT,
    payload,
  };
}

export function getChecksSuccess(payload) {
  return {
    type: GET_CHECKS_SUCCESS,
    payload,
  };
}

export function completeFormSubmit() {
  return {
    type: COMPLETE_FORM_SUBMIT,
  };
}

export const initialState = {
  // Пакет сведений, передаваемых в рамках обращения 1151020 (3-НДФЛ)
  ndfl3Package: {},
  // объект обращения, готовый для подписывания, шифрования и отправки в ГП-3
  xmlDraft: {},
  // Справки ndfl2 за выбранный год
  ndfl2: null,
  // Регионы
  countries: [],
  // Профиль пользователя
  personalInfo: {},
  // Доходы по ndfl2
  incomeSources: [],
  // Справочник вид документа, удостоверяющего личность
  documentTypes: [],
  // Справочник ИФНС
  taxAuthoritiesContacts: [],
  // ИФНС по месту регистрации (список)
  isDisableTaxInspection: false,
  isDialogSetTaxInspection: false,
  dictionaries: {
    taxDeductionOwnerCodes: { data: [] },
    objectNameCodes: { data: [] },
    propertyRights: { data: [] },
    actionTypes: { data: [] },
    // Справочник типов доходов
    incomeTypes: { data: [] },
    // Стандартный вычет на детей
    childdeductions: { data: {} },
    // Справочник кодов вычетов
    deductionTypes: { data: [] },
    // Справочник Категории Налогоплательщика
    taxPayerCategories: { data: [] },
    logout: false,
  },
  checks: [],
  declarationSubmitted: false,
  // Состояние подписания аттачей в GP3 контейнере и обновления декларации
  updating3NDFLDraftAttaches: {
    loading: false,
    error: null,
  },
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case GET_COUNTRIES_SUCCESS: {
      const countries = uniqBy(
        action.payload
          .map((country) => ({
            label: `${country.code} - ${country.shortName} `,
            value: country.code,
          }))
          .filter((country) => country.value !== 'RUS')
          .sort((a, b) => a.value - b.value),
        (item) => item.value,
      );

      return Object.assign({}, state, {
        countries,
      });
    }

    case GET_2NDFL_SUCCESS: {
      const ndflByYear = action.payload;
      return Object.assign({}, state, {
        ndfl2: ndflByYear,
      });
    }

    case GET_INCOME_SOURCE_BY_2NDFL_SUCCESS: {
      return { ...state, incomeSources: action.payload };
    }

    case GET_DOCUMENT_TYPES_SUCCESS: {
      const documentTypes = action.payload.map((item) => ({
        label: item.name,
        value: item.code,
      }));

      return Object.assign({}, state, {
        documentTypes,
      });
    }

    case GET_TAX_AUTHORITIES_CONTACTS: {
      const inspection = action.payload.inspection;

      const taxAuthoritiesContacts = action.payload.activeTaxAuthorities.map((item) => ({
        label: item.code + ' - ' + item.name,
        value: item.code,
      }));

      return update(state, {
        taxAuthoritiesContacts: { $set: taxAuthoritiesContacts },
        isDisableTaxInspection: { $set: inspection && true },
        isDialogSetTaxInspection: { $set: isEmpty(taxAuthoritiesContacts) },
      });
    }

    case SELECT_CHECKBOX_2NDFL: {
      const ndfl2Id = state.ndfl2[action.index].ndfl2Id;

      const ndfl2 = state.ndfl2.map((item) => {
        if (item.ndfl2Id === ndfl2Id) {
          item.isSelect = !action.isSelect;
        }
        return item;
      });

      return Object.assign({}, state, {
        ndfl2,
      });
    }

    case DISABLE_CHECKBOX_2NDFL: {
      const ndfl2 = state.ndfl2.map((item) => {
        if (item.ndfl2Id === action.ndfl2Id) {
          item.isDisabled = true;
        }
        return item;
      });

      return Object.assign({}, state, {
        ndfl2,
      });
    }

    case CLEAR_3NDFL_DRAFT:
      return initialState;

    case INIT_3NDFL_DRAFT_SUCCESS:
      return Object.assign({}, state, {
        ndfl3Package: action.ndfl3Package,
      });

    case GET_3NDFL_DRAFT_SUCCESS:
      return Object.assign({}, state, {
        ndfl3Package: action.ndfl3Package,
      });

    case SAVE_3NDFL_DRAFT_SUCCESS:
      return { ...state, ndfl3Package: action.responseNdfl3Package };

    case SAVE_3NDFL_DRAFT_ERROR:
      return { ...state, error: action.error };

    case CREATE_3NDFL_XML_DRAFT_ERROR:
      return {
        ...state,
        xmlDraft: {
          error: action.payload,
        },
      };

    case CREATE_3NDFL_XML_DRAFT_SUCCESS:
      return Object.assign({}, state, {
        xmlDraft: action.xmlDraft,
      });

    case SET_LOGOUT: {
      return Object.assign({}, state, { logout: action.payload });
    }

    case GET_CHECKS_SUCCESS: {
      const allChecks = get(action, 'payload.content', []);

      return Object.assign({}, state, {
        checks: filter(allChecks, (check) => {
          return check.operationType === 'INCOME';
        }),
      });
    }

    case COMPLETE_FORM_SUBMIT: {
      return {
        ...state,
        loading: false,
        declarationSubmitted: true,
      };
    }

    case RESET_FORM_SUBMIT: {
      return {
        ...state,
        loading: false,
        declarationSubmitted: false,
      };
    }

    default:
      return getNDFL3Reducer(state, action);
  }
}
